import Act from "../actions";

const initState = {};

const gisReducer = (state = initState, action) => {
  switch (action.type) {
    case Act.TEST:
      return { ...state };
    default:
      return state;
  }
};
export default gisReducer;
